import React from 'react';
import { Carousel } from '@banhala/ui-kit';
import type { LoopScrollCarouselProps } from './LoopScrollCarousel';

export type { LoopScrollCarouselProps };

/**
 * LoopScrollCarousel의 web 변형.
 *
 * Web의 ScrollView + pagingEnabled (CSS scroll-snap) 은 관성 스크롤로 2~3장씩 넘어가는
 * 이슈가 있어 ui-kit `Carousel`을 그대로 사용한다.
 * native(`.tsx`) 변형은 자체 ScrollView 구현을 사용하여 brownfield Dimensions 캐시 의존을 제거.
 */
export const LoopScrollCarousel = <T,>({
  data,
  width,
  height,
  renderItem,
  loop = true,
  autoPlay = false,
  autoPlayInterval = 3000,
  onSnapToItem,
  onScrollStart,
  onScrollEnd,
  style,
  testID,
}: LoopScrollCarouselProps<T>) => {
  return (
    <Carousel<T>
      data={data}
      vertical={false}
      loop={loop}
      width={width}
      height={height}
      autoPlay={autoPlay}
      autoPlayInterval={autoPlayInterval}
      renderItem={args => <>{renderItem(args)}</>}
      onSnapToItem={onSnapToItem}
      onScrollStart={onScrollStart}
      onScrollEnd={onScrollEnd}
      style={style}
      testID={testID}
    />
  );
};
